export enum ErrorMessage {
    FreeWallNotFound = 'FreeWall window not found'
}
